// Web mock for react-native-picker-select using HTML select
import React from 'react';
import { View, StyleSheet } from 'react-native';

interface Item {
  label: string;
  value: any;
  key?: string;
  color?: string;
}

interface PickerSelectProps {
  onValueChange: (value: any, index: number) => void;
  items: Item[];
  value?: any;
  placeholder?: { label: string; value: any; color?: string };
  disabled?: boolean;
  style?: any;
  children?: React.ReactNode;
}

const RNPickerSelect: React.FC<PickerSelectProps> = ({
  onValueChange,
  items,
  value,
  placeholder,
  disabled,
  style,
  children,
}) => {
  const allItems = placeholder
    ? [{ label: placeholder.label, value: placeholder.value }, ...items]
    : items;

  return (
    <View style={[styles.container, style?.viewContainer]}>
      <select
        value={value ?? ''}
        onChange={(e) => {
          const selectedIndex = e.target.selectedIndex;
          const selectedValue = allItems[selectedIndex]?.value;
          onValueChange(selectedValue, selectedIndex);
        }}
        disabled={disabled}
        style={{
          width: '100%',
          padding: 10,
          fontSize: 16,
          border: '1px solid #ccc',
          borderRadius: 4,
          backgroundColor: 'white',
          fontFamily: 'TCCC-UnityHeadline Regular',
          ...style?.inputWeb,
        }}
      >
        {allItems.map((item, index) => (
          <option key={item.key || `${item.value}-${index}`} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%' as any,
  },
});

export default RNPickerSelect;
